import { render, staticRenderFns } from "./PracticalTask.vue?vue&type=template&id=27a0bdcc&scoped=true&"
import script from "./PracticalTask.vue?vue&type=script&lang=js&"
export * from "./PracticalTask.vue?vue&type=script&lang=js&"
import style0 from "./PracticalTask.vue?vue&type=style&index=0&id=27a0bdcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a0bdcc",
  null
  
)

export default component.exports